// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"d7e4a5ff","423":"d7e4a5ff","496":"1769112d","841":"1769112d","924":"30273c83"}[chunkId] + ".chunk.css";
};